












import { Component, Prop, Vue } from 'vue-property-decorator'
import { PropType } from 'vue'
import OpenCard from '@/components/OpenCard.vue'
import DateTools from '@/DateTools'
import { TrelloCard } from '../TrelloClient'

@Component({
    components: {
        OpenCard,
    },
    props: {
        dueDate: String, // giorno di scadenza
        cards: Array as PropType<TrelloCard[]>, // card con quel giorno di scadenza
    },
})
export default class extends Vue {

    get daysFromDate() {
        return DateTools.daysFromToday((this as any).dueDate)
    }

}

